import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';


@Component({
  selector: 'field-wrapper',
  templateUrl: './field-wrapper.component.html',
  imports: [FormlyModule]
})
export class FieldWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
}
